export const calculateDurationFormatted = (startedAt: number, finishedAt: number) => {
  let duration = finishedAt - startedAt;

  if (duration < 0) {
    duration = 0;
  }

  const seconds = Math.floor(duration / 1000);
  const milliseconds = duration % 1000;

  return `${seconds}.${milliseconds.toString().padStart(3, '0')}s`;
};

export const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};
